<template>
  <baseEdit />
</template>

<script>
  import baseEdit from './voucherBaseEdit';

  export default {
    name: 'detailVoucher',
    components: {
      baseEdit,
    },
  };
</script>
